import { rtkApi } from '@/shared/api/rtkApi';

interface DeleteAccountResponse {
  status: string;
}

interface DeleteAccountRequest {
  ids: number[];
  reason: string;
}

interface HardDeleteAccountRequest {
  ids: number[];
}

const deleteAccountApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    deleteAccount: build.mutation<DeleteAccountResponse, DeleteAccountRequest>({
      query: ({ ids, reason }) => ({
        url: `/v1/superadmin/user/${ids.join(';')}`,
        method: 'DELETE',
        body: { reason },
      }),
      invalidatesTags: ['UsualTable'],
    }),
    hardDeleteAccount: build.mutation<DeleteAccountResponse, HardDeleteAccountRequest>({
      query: ({ ids }) => ({
        url: `/v1/superadmin/user/${ids.join(';')}/hard-delete`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UsualTable'],
    }),
  }),
});

export const { useDeleteAccountMutation, useHardDeleteAccountMutation } = deleteAccountApi;
